import type { Socket } from "socket.io-client"
import { io } from "socket.io-client"

import { env } from "@/env"

let socket: Socket | null = null
let refCount = 0

/**
 * One connection per tab, shared by thread locks and presence. The instance is
 * never closed, because socket.io-client hands the same object back to the next
 * `io()` call and a closed one never reconnects.
 */
export function acquireWorkspaceSocket(): {
	socket: Socket
	release: () => void
} {
	socket ??= io(env.VITE_SOCKET_IO_URL, {
		path: "/io",
		transports: ["websocket"],
		reconnection: true,
		reconnectionDelay: 1000,
		reconnectionDelayMax: 5000,
	})
	refCount += 1

	const acquired = socket
	if (!acquired.connected) acquired.connect()

	let released = false

	return {
		socket: acquired,
		release: () => {
			if (released) return
			released = true
			refCount -= 1
			if (refCount > 0) return
			acquired.disconnect()
		},
	}
}
